const colors = {
  mintGreen: '#d9e3d8',
  mediumPurple: '#462f44',
  blackPurple: '#210b1e',
  gray: '#f4f4f4',
  white: '#ffffff',
} as const;

// Convert hex colors to OKLCH
const convertedColors = {
  mediumPurple: 'oklch(34.1%, 12%, 329.559%)',
  mintGreen: 'oklch(90.5%, 4.5%, 142.816%)',
  gray: 'oklch(96.7%, 0%, 89.876%)',
  blackPurple: 'oklch(19.3%, 12.25%, 332.659%)',
  white: 'oklch(100%, 0%, 89.876%)',
};

export { colors, convertedColors };
